<template>
  <div>
    <div class="tab_nav_box">
      <div class="nav_box_left">
        <a-tabs v-model:activeKey="tabsIndex" @change="changeTab">
          <a-tab-pane v-for="item in tabsList" :key="item.index">
            <template #tab>
              <span
                class="tabs_txt"
                :class="[tabsIndex == item.index && 'tabs_av']"
                >{{ item.title }}</span>
            </template>
          </a-tab-pane>
        </a-tabs>
      </div>
      <div class="nav_box_right">
        <div v-show="tabsIndex == 0" class="select_box">
          <a-select
            v-model:value="state.batchIndex"
            :options="state.batchList"
            size="middle"
            style="min-width: 230px"
          />
        </div>
      </div>
    </div>
    <div class="content_box">
      <Dissertation
        v-show="tabsIndex == 0"
        :show="tabsIndex == 0"
        :batch-index="state.batchIndex"
        :batch-data="state.activeBatchData"
      />
      <Enroll
        v-show="tabsIndex == 1"
        v-model:batchIndex="state.batchIndex"
        v-model:tabsIndex="tabsIndex"
        :show="tabsIndex == 1"
        :batch-list="state.batchList"
        :batch-data="state.activeBatchData"
      />
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, watch } from "vue";
import Dissertation from "@/views/my_page/dissertation/dissertation.vue";
import Enroll from "@/views/my_page/dissertation/enroll.vue";
import { getPaperBatchList,getIsApply } from "@/api/my_page/paper/index.js";

import { message } from "ant-design-vue";

const tabsIndex = ref(0);
const tabsList = [
  { title: "我的学位申请", index: 0 },
  { title: "学位申请报名", index: 1 },
];
const state = reactive({
  batchList: [], // 批次筛选数据
  batchData: [], // 批次列表
  activeBatchData: {}, // 选中的批次
  batchIndex: null,
});
watch(
  () => state.batchIndex,
  (newVal) => {
    state.activeBatchData =
      state.batchData.find((item) => item.id == newVal) || {};
  }
);
// 是否允许打开 学位申请报名页面
const isapply = ref(false);
function getIsApplyFn() {
  getIsApply().then((res) => {
    isapply.value = res;
  });
}
getIsApplyFn();
// 切换tab事件
function changeTab(e) {
  if (e === 1 && isapply.value) {
    tabsIndex.value = 0;
    message.error("学位申请已存在!");
  }
}
// 获取论文批次
function getBatchList() {
  let params = {
    paperType: 2,
  };
  getPaperBatchList(params).then((res) => {
    // console.log("获取学位论文批次===", res);
    let list = [];
    res.forEach((item) => {
      list.push({
        label: item.year + (item.season == "S" ? "春季" : "秋季"),
        value: item.id,
        year: item.year,
        season: item.season,
      });
    });
    state.batchData = res;
    state.batchList = list;
    state.batchIndex = res[0]?.id;
  });
}
getBatchList();
</script>

<style lang="less" scoped>
.content_box {
  padding: 0 25px 15px;
}
.select_box {
  padding-right: 30px;
  height: 100%;
  display: flex;
  align-items: center;
}

.tab_nav_box {
  position: relative;
  width: 100%;
  display: flex;
  .nav_box_left {
    flex: 1;
  }
  .nav_box_right {
    margin-bottom: 16px;
    border-bottom: 1px solid #f0f0f0;
  }
}
.tabs_txt {
  padding: 0 20px;
  color: #9c999c;
  font-weight: 600;
  font-size: 14px;
  &:hover {
    color: #1963f7;
  }
}
.tabs_av {
  color: #7a6666 !important;
}
</style>
